<template>
    <LayoutsDefaultHeaderOmnibox />
    <LayoutsDefaultHeaderTheme />
    <LayoutsDefaultHeaderNotifications />
    <LayoutsDefaultHeaderAccount />
</template>
